/** Placeholder shown while a route's data is in flight. */
export function PageSkeleton() {
  return (
    <div className="cng-skeleton" aria-busy="true" aria-live="polite">
      <span />
      <span />
      <span />
      <span />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
